<template>
  <div class="index">
    <div class="top">
      <img src="../img/top.png" alt="" />
      <div class="text-box">
        <div class="left">解决方案</div>
        <div class="bottom">长期致力于为用户提供多场景全方位解决方案</div>
      </div>
      <ul class="ul">
        <li class="li" v-for="(item, index) in list" :key="index" @click="jump(item)" :class="route === item.route ? 'checked' : ''">
          <div class="li-text">
            {{ item.name }}
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'maninDody',
  data() {
    return {
      list: [
        {
          name: '智慧城市',
          route: '/solve/city'
        },
        {
          name: '智慧旅游',
          route: '/solve/tourism'
        },
        {
          name: '智慧城镇',
          route: '/solve/town'
        },
        {
          name: '数字乡村',
          route: '/solve/village'
        },
        {
          name: '智慧园区',
          route: '/solve/park'
        }
      ]
    };
  },
  computed: {
    route() {
      return this.$route.path;
    }
  },
  watch: {},
  methods: {
    jump(item) {
      let { fullPath } = this.$route;
      if (!item.route) {
        return;
      }
      if (fullPath === item.route) {
        return;
      }
      this.$router.push({
        path: item.route
      });
    }
  },
  mounted() {}
};
</script>

<style scoped lang="scss">
@import url('~@/icons/pingfang/font.css');
.index {
  .top {
    position: relative;
    img {
      // height: 710px;
      width: 100%;
      height: auto;
    }
    .text-box {
      width: 620px;
      color: #fff;
      font-size: 70px;
      position: absolute;
      top: 40%;
      left: 55%;
      transform: translate(-50%, -50%);
      .left {
        text-align: left;
      }
      .bottom {
        margin-left: 60px;
        margin-top: 50px;
        font-size: 28px;
      }
    }
    .ul {
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      height: 98px;
      background: rgba(255, 255, 255, 0.2);
      display: flex;
      justify-content: space-evenly;
      align-items: center;
      .li {
        font-size: 28px;
        cursor: pointer;
        color: #fff;
        font-family: 'PingFang';
        &:hover {
          color: #f15030;
        }
      }
      .checked {
        .li-text {
          color: #f15030;
        }
        &::before {
          width: 100%;
        }
      }
    }
  }
}
</style>
